import AppAbout from '../components/app/About';
import AppHelp from '../components/app/Help';
import AppContactForm from '../components/app/ContactForm';
import Tos from '../components/app/TOS';

export default [
    {
        name: 'AppAbout',
        path: '/about',
        component: AppAbout,
        meta: {
            title: 'global.menu.about'
        }
    },
    {
        name: 'AppHelp',
        path: '/help',
        component: AppHelp,
        meta: {
            title: 'global.menu.help'
        }
    },
    {
        name: 'AppContactForm',
        path: '/contact',
        component: AppContactForm,
        meta: {
            title: 'global.menu.contactForm'
        }
    },
    {
        name: 'Tos',
        path: '/terms-of-services',
        component: Tos,
        meta: {
            title: 'global.menu.tos'
        }
    },
];



// WEBPACK FOOTER //
// ./src/routes/app.js